import axios from "../../config/axiosConfig";
import { DELIVERY_CHALLAN_RETURN_TRANSACTION_REQUEST, DELIVERY_CHALLAN_RETURN_TRANSACTION_REQUEST_FAILURE, GET_DELIVERY_CHALLAN_RETURN_TRANSACTIONS_TAKA_NO } from "../types";

export const getDeliveryChallanReturnTransactionTakaNo = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_RETURN_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/delivery-challan-return-transaction/getAll", { params }).then((response) => {
        const takaNos = response.data.map((data) => data.Taka_No);
        if (response.data) {
          dispatch({ type: GET_DELIVERY_CHALLAN_RETURN_TRANSACTIONS_TAKA_NO, payload: takaNos });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_RETURN_TRANSACTION_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_RETURN_TRANSACTION_REQUEST_FAILURE, error: error.message });
    }
  };
};

